import { userApi } from './http';

function unwrap(response) {
  return response?.data || response;
}

export async function fetchLawyerCalendarSlots(lawyerProfileId, date) {
  const { data } = await userApi.get(`/lawyer/${encodeURIComponent(lawyerProfileId)}/slots?date=${encodeURIComponent(date)}`);
  return Array.isArray(data) ? data : [];
}

function eachDateInRange(startDate, endDate) {
  const dates = [];
  const cursor = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);

  while (cursor <= end) {
    const year = cursor.getFullYear();
    const month = String(cursor.getMonth() + 1).padStart(2, '0');
    const day = String(cursor.getDate()).padStart(2, '0');
    dates.push(`${year}-${month}-${day}`);
    cursor.setDate(cursor.getDate() + 1);
  }

  return dates;
}

function toFallbackDay(date, slots) {
  const safeSlots = Array.isArray(slots) ? slots : [];
  const summary = {
    total: safeSlots.length,
    available: safeSlots.filter((slot) => slot?.available).length,
    booked: safeSlots.filter((slot) => slot?.booked).length,
    blocked: safeSlots.filter((slot) => slot?.blocked).length,
    past: safeSlots.filter((slot) => slot?.past).length,
  };

  return {
    date,
    holiday: safeSlots.some((slot) => slot?.holiday),
    dayAvailability: null,
    blockedSlots: safeSlots.filter((slot) => slot?.blocked).map((slot) => slot.time),
    slots: safeSlots,
    summary,
  };
}

export async function fetchLawyerCalendarRange(startDate, endDate, lawyerProfileId) {
  try {
    const { data } = await userApi.get(
      `/lawyer/calendar?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
    );
    return Array.isArray(data?.days) ? data.days : [];
  } catch (error) {
    const isRouteMissing = Number(error?.response?.status) === 404;
    if (!isRouteMissing || !lawyerProfileId) {
      throw error;
    }

    const dates = eachDateInRange(startDate, endDate);
    const responses = await Promise.all(
      dates.map(async (date) => {
        try {
          const slots = await fetchLawyerCalendarSlots(lawyerProfileId, date);
          return toFallbackDay(date, slots);
        } catch {
          return toFallbackDay(date, []);
        }
      })
    );

    return responses;
  }
}

export async function addHoliday(date, fullDay = true) {
  const { data } = await userApi.post('/lawyer/holiday', { date, fullDay });
  return unwrap(data);
}

export async function removeHoliday(date) {
  const { data } = await userApi.delete('/lawyer/holiday', { data: { date } });
  return unwrap(data);
}

export async function blockSlots(date, slots) {
  const { data } = await userApi.post('/lawyer/block-slot', { date, slots });
  return unwrap(data);
}

export async function unblockSlots(date, slots) {
  const { data } = await userApi.delete('/lawyer/block-slot', { data: { date, slots } });
  return unwrap(data);
}